export default __webpack_public_path__ + "static/media/Roboto-Thin.0c8b0410.ttf";